export type EntityReferenceType = "client" | "contract" | "equipment" | "job";

export const buildEntityDetailRoute = (
  type: EntityReferenceType,
  id: string | number
): string => {
  switch (type) {
    case "client":
      return `/clients/${id}`;
    case "contract":
      return `/contracts/${id}`;
    case "equipment":
      return `/equipment-section/equipments/${id}`;
    case "job":
      return `/service/jobs/${id}`;
    default:
      return "/";
  }
};
